export const filterVisibleHosts = ({
  canViewOtherHidden,
  hostEmployeeId,
  hosts,
}) =>
  hosts?.filter((host) => {
    if (!canViewOtherHidden) return !host?.isHidden;
    if (hostEmployeeId)
      return host?.isHidden ? host?.id !== hostEmployeeId : true;

    return true;
  });
